module.exports = __webpack_public_path__ + "static/media/3d-plan_roots.2b6ce76a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_roots.svg
// module id = 1030
// module chunks = 0